import { browserHistory } from 'react-router'

/**
 * @param {Object} query
 */
export const addQuery = (query) => {
  const location = Object.assign({}, browserHistory.getCurrentLocation())
  Object.assign(location.query, query)
  browserHistory.push(location)
}

/**
 * @param {...String} queryNames
 */
export const removeQuery = (...queryNames) => {
  const location = Object.assign({}, browserHistory.getCurrentLocation())
  queryNames.forEach((q) => delete location.query[q])
  browserHistory.replace(location)
}

/**
 * Because we're preventing the default behavior for clicking on links, we need to manually
 * dispatch a custom event to inform chat widget about url changes that browserHistory handles.
 */
export const browserHistoryMutationSideEffects = () => {
  document.dispatchEvent(new CustomEvent('historyChanged'))
}
